import { toast } from 'react-toastify';
import { 
  CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_BEGIN,
  CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_SUCCESS,
  CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_FAILURE
} from './constants';
import initialState from './initialState';


export const beginUploadExcelPrices = () => async (dispatch) =>{
  dispatch({
      type: CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_BEGIN
    })
  }

export const uploadExcelPrices = (data) => async (dispatch) =>{
  try {
    dispatch({
      type: CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_SUCCESS,
      data: data
    })
  } catch (error) {
    toast.error(error,{ autoClose: false})
    dispatch({
      type: CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_FAILURE,
      data: error
    })
  }
} 

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_BEGIN:
      return {
        ...state,
        uploadExcelPricesPending: true,
        uploadExcelPricesError: false,
        uploadExcelPricesFinish: false
      };
    case CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_SUCCESS:
      return {
        ...state,
        uploadExcelPricesPending: false,
        uploadExcelPricesError: false
      };
    case CAR_DATA_MASTER_UPLOAD_EXCEL_PRICES_FAILURE:
      return {
        ...state,
        uploadExcelPricesPending: false,
        uploadExcelPricesError: action.data
      };
    default: 
      return state;
  }
}
